// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAoWktmxxPCbCFRsFIGctV9jeCQdyyEAAY",
  authDomain: "memealchemist-f1b05.firebaseapp.com",
  projectId: "memealchemist-f1b05",
  storageBucket: "memealchemist-f1b05.appspot.com",
  messagingSenderId: "604178145042",
  appId: "1:604178145042:web:4d26c688423556385d9dcb",
  measurementId: "G-RJ1TQL1YXC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export { db };
